<app-page-header title="Profili" [showBack]="false">
  <div class="d-flex align-items-center">
    @if (authService.hasRole('PRODUCT_CAN_WRITE')) {
    <button class="mr-4" mat-flat-button color="primary" [routerLink]="['new']">Crea profilo</button>
    }

    <bitf-search
      (valueChanges)="searchText = $event"
      placeholder="Cerca profilo"
      label="Cerca profilo"
      [isInToolbar]="true"
      [hasSearchIcon]="false"
    ></bitf-search>
  </div>
</app-page-header>

<div class="container-fluid py-3">
  <app-dynamic-table
    [service]="profileService"
    [columns]="dataColumns"
    showDeleteBtn="custom"
    (canDelete)="canDelete($event)"
    [searchText]="searchText"
  ></app-dynamic-table>
</div>
